// The list lives in paypal_constants.rb and arrives as paypalProps.currencies.
// Fails open on a missing list — the server gates still hold, and losing PayPal
// platform-wide on a plumbing regression is the worse failure.
export const paypalCurrencySupported = (isoCode, currencies) =>
  !currencies?.length || currencies.includes(isoCode)

export default paypalCurrencySupported
